import workAnimation from '@/assets/images/top/usecase/animation-work.webp';
import studyAnimation from '@/assets/images/top/usecase/animation-study.webp';
import healthAnimation from '@/assets/images/top/usecase/animation-health.webp';
import hobbyImg from '@/assets/images/top/usecase/hobby1.png';
import familyImg from '@/assets/images/top/usecase/family1.png';

export type TopUsecaseAsset = {
    id: string;
    image: string;
};

/**
 * ユースケースのメディア情報（文言は i18n から取得）
 */
export const topUsecaseAssets: TopUsecaseAsset[] = [
    {
        id: 'work',
        image: workAnimation,
    },
    {
        id: 'learning',
        image: studyAnimation,
    },
    {
        id: 'wellness',
        image: healthAnimation,
    },
    {
        id: 'hobby',
        image: hobbyImg,
    },
    {
        id: 'family',
        image: familyImg,
    },
];
